export const CROAS_OPTIONS = [
  "Sicilia", "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna",
  "Friuli-Venezia Giulia", "Lazio", "Liguria", "Lombardia", "Marche", "Molise",
  "Piemonte", "Puglia", "Sardegna", "Toscana", "Trentino-Alto Adige", "Umbria",
  "Valle d'Aosta", "Veneto", "Non iscritto/Altro professionista",
];

export const SICILY_PROVINCES = [
  "Agrigento", "Caltanissetta", "Catania", "Enna", "Messina",
  "Palermo", "Ragusa", "Siracusa", "Trapani", "Altra Provincia",
];
